import {Record} from 'immutable';

import {type MonthlyPrice, BookingType} from './session-booking';

interface IProductBooking {
    readonly bookingType: BookingType;
    readonly day: string;
    readonly productId: string;
    readonly productVersion: string;
    readonly monthlyPrices: MonthlyPrice[];
    readonly amount: number;
}

export class ProductBooking extends Record<IProductBooking>({
    bookingType: BookingType.ProductBooking,
    day: '',
    productId: '',
    monthlyPrices: [],
    productVersion: '',
    amount: 0,
}) {}

const fromAPI = (data: any) => {
    return new ProductBooking({
        ...data,
    });
};

export default {
    record: ProductBooking,
    default: new ProductBooking(),
    fromAPI,
};
